import cx from 'classnames'
import PropTypes from 'prop-types'

import {BASE_CLASS, DEFAULT_EMPTY_OPTIONS, DEFAULT_EMPTY_SINGLE_VALUE, NO_OP} from '../../config.js'
import FilterBasicLegacySingleSelectionItem, {filterBasicLegacySingleSelectionItemDesigns} from './Item/index.js'

const FilterBasicLegacySingleSelection = ({
  design,
  onChange = NO_OP,
  options = DEFAULT_EMPTY_OPTIONS,
  value = DEFAULT_EMPTY_SINGLE_VALUE
}) => {
  const baseClass = cx(BASE_CLASS, `${BASE_CLASS}-list`)

  const handleChange = ({id, label}) => onChange({id, label})

  return (
    <ul className={baseClass}>
      {options.map(({extendedInfo, icon, id, isDisabled, isHighlighted, label}) => {
        const isSelected = String(value) === String(id)

        return (
          <li className={`${BASE_CLASS}-singleSelectionItemWrapper`} key={id}>
            <FilterBasicLegacySingleSelectionItem
              design={design}
              extendedInfo={extendedInfo}
              icon={icon}
              id={id}
              isDisabled={isDisabled}
              isHighlighted={isHighlighted}
              isSelected={isSelected}
              label={label}
              onChange={handleChange}
            />
          </li>
        )
      })}
    </ul>
  )
}

FilterBasicLegacySingleSelection.displayName = 'FilterBasicLegacySingleSelection'
FilterBasicLegacySingleSelection.propTypes = {
  design: PropTypes.oneOf(Object.values(filterBasicLegacySingleSelectionItemDesigns)),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.func,
      id: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string.isRequired
    })
  ),
  value: PropTypes.string
}

export {FilterBasicLegacySingleSelectionItem, filterBasicLegacySingleSelectionItemDesigns}

export default FilterBasicLegacySingleSelection
